import { Action } from '../../models';
import { Component,
         EventEmitter,
         HostBinding,
         Input,
         Output } from '@angular/core';

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html'
})
export class NotificationComponent {

  constructor() { }

  /**
   * A boolean indicating whether or not the notification should contain a
   * button that allows the user to dismiss it
   */
  @Input() dismissable = false;

  /**
   * Exposes the name of the notification in the DOM via the
   * `data-notification-name` attribute
   */
  @HostBinding('attr.data-notification-name') @Input() name: string;

  /**
   * The EventEmitter for informing the parent component of user interaction
   * with the notification
   */
  //@Output() notificationEvent = new EventEmitter<Action>();

  /**
   * Informs the parent component that the user has dismissed the notification
   */
  onDismiss(): void {
    // this.notificationEvent.emit({
    //   type: 'dismiss-notification',
    //   value: this.name
    // });
  }

}
